export default __webpack_public_path__ + "static/media/concentTextImage.8ab308f2.svg";